const loadBundles = () => {
  document.addEventListener("DOMContentLoaded", () => {
    /* Accordion */
    const accordions = document.querySelectorAll(
      '[data-behaviour="accordion"]'
    );

    if (accordions.length > 0) {
      import("@/components/accordion").then(({ render }) => {
        accordions.forEach((accordion) => {
          render(accordion);
        });
      });
    }

    /* Carousel */
    const carousel = document.querySelectorAll('[data-behaviour="carousel"]');

    if (carousel.length > 0) {
      import("@/components/carousel").then(({ render }) => {
        carousel.forEach((carousel) => {
          render(carousel);
        });
      });
    }

    /* Marquee */
    const marquees = document.querySelectorAll('[data-behaviour="marquee"]');

    if (marquees.length > 0) {
      import("@/components/marquee").then(({ render }) => {
        marquees.forEach((marquee) => {
          render(marquee);
        });
      });
    }

    /* WooCommerce Loading States */
    // Check if we're on a WooCommerce page
    const isWooCommercePage = document.body.classList.contains('woocommerce') || 
                             document.body.classList.contains('woocommerce-page') ||
                             document.body.classList.contains('single-product') ||
                             document.body.classList.contains('archive-product') ||
                             document.body.classList.contains('cart') ||
                             document.body.classList.contains('checkout') ||
                             document.body.classList.contains('my-account');

    if (isWooCommercePage) {
      import("@/components/woocommerce/loading").then(({ render }) => {
        render();
      });
    }

    /* WooCommerce Menu Cart */
    // Check if WooCommerce is active and we have cart elements
    const hasWooCommerceCart = document.querySelector('.woocommerce-menu-cart-count, .woocommerce-menu-cart-count-mobile');
    
    if (hasWooCommerceCart && typeof wc_cart_fragments_params !== 'undefined') {
      import("@/components/woocommerce/menu-cart").then(({ render }) => {
        render();
      });
    }
  });
};

export default loadBundles;
